import { type ThemeConfig, theme as antdTheme } from 'antd'

export const darkTheme: ThemeConfig = {
  hashed: false,
  cssVar: {
    prefix: '',
  },
  algorithm: antdTheme.darkAlgorithm,
  token: {
    colorPrimary: '#F46036',
    colorLink: '#F46036',
    colorInfo: '#488BE8',
    colorSuccess: '#79C886',
    colorWarning: '#FAAD14',
    colorError: '#F14D5B',
    fontFamily: 'Roboto, sans-serif',
    colorBgBase: '#000000',

    tekheletPurple50: '#432F91',
    tekheletPurple40: '#5039B0',
    tekheletPurple30: '#5C45C2',
    tekheletPurple20: '#6F5AC9',
    tekheletPurple10: '#4C36A8',
    tekheletPurple5: '#47329B',
    tekheletPurple1: '#412E8C',
    tekheletPurple: '#DDD7F2',
    royalPurple80: '#CCB8E6',
    royalPurple60: '#9374C3',
    royalPurple50: '#8150BF',
    royalPurple40: '#703FAD',
    royalPurple30: '#5F3594',
    royalPurple5: '#361F54',
    royalPurple1: '#321E49',
    royalPurple: '#1F0053',
  },
  components: {
    Layout: {
      headerBg: '#000000',
    },
    Menu: {
      itemBg: '#000000',
    },
  },
}
